module.exports = __webpack_public_path__ + "2bbf4fb2b0d96a3233d520d062100ac4.svg";